module.exports = __webpack_public_path__ + "img/booking-client.5f91688e.svg";